module.exports = __webpack_public_path__ + "static/media/sankalpsemi.f1a0b1c7.png";